import { EntityLocationInfo } from '../../../slices/profiles-data-slice/models/entity-location-info';
import { PracticeProfileImage } from '../../../slices/profiles-data-slice/models/practice-profile-image';

/**
 * The location whose images the carousel shows: the user's selection when it
 * belongs to the given locations, otherwise the first location (default).
 */
export const resolveEffectiveImagesLocationId = (
    locations: EntityLocationInfo[],
    selectedLocationId: string
): string | undefined =>
    locations.some((location) => location.id === selectedLocationId)
        ? selectedLocationId
        : locations[0]?.id;

/**
 * Carousel image sources for the effective location. A practice without
 * locations falls back to its practice-level uploads (legacy behavior).
 */
export const getCarouselImages = (
    locations: EntityLocationInfo[],
    practiceUploads: PracticeProfileImage[] | undefined,
    effectiveLocationId: string | undefined
): string[] => {
    const imagesSource = locations.length
        ? locations.find((location) => location.id === effectiveLocationId)
              ?.uploads
        : practiceUploads;

    return (
        imagesSource
            ?.filter((img) => img && img.source && img.source.trim() !== '')
            .slice()
            .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
            .map((img) => img.source) || []
    );
};
